<template>
    <div>
      <v-btn small>+</v-btn>
    </div>
</template>

<script>
export default {
  name: 'CircleButton',
};
</script>

<style lang="scss" scoped>
  @import "src/assets/css/variables.scss";
  .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
    background-color: $submit-color;
    color: white;
    font-size: 20px;
    display:block;
    height: 45px;
    width: 40px;
    border-radius: 50%;
    border: 1px solid $submit-color;
  }
  .v-btn{
    margin-bottom: 25px
  }
</style>
